import { render, staticRenderFns } from "./RaddarChart.vue?vue&type=template&id=385dd108&"
import script from "./RaddarChart.vue?vue&type=script&lang=js&"
export * from "./RaddarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385dd108')) {
      api.createRecord('385dd108', component.options)
    } else {
      api.reload('385dd108', component.options)
    }
    module.hot.accept("./RaddarChart.vue?vue&type=template&id=385dd108&", function () {
      api.rerender('385dd108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/RaddarChart.vue"
export default component.exports